import { render, staticRenderFns } from "./EditOrderJson.vue?vue&type=template&id=1ab5f6cd&scoped=true&"
import script from "./EditOrderJson.vue?vue&type=script&lang=js&"
export * from "./EditOrderJson.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderJson.vue?vue&type=style&index=0&id=1ab5f6cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5f6cd",
  null
  
)

/* custom blocks */
import block0 from "./EditOrderJson.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports